export const en = {
    ad: 'Ad',
    'ad-description': 'Form for creating and configuring a new ad',
    add: 'Add',
    campaign: 'Campaign',
    'campaign-description': 'Campaign type determines where an ad is served',
    group: 'Ad group',
    'group-limit-description': 'An empty ad group where you can create up to {limit} new ads',
    phrase: 'Keywords',
    'phrase-description': 'Keyword planner to help you find effective keywords'
};
